import React, { useState, useRef, useEffect } from "react";

import Btn from "components/Custom/Btn";
import PopoverBtn from "components/Custom/PopoverBtn";
import ChkBox from "components/Custom/ChkBox";
import TxtRow from "components/Custom/TxtRow";
import ReplayIcon from "@mui/icons-material/Replay";

import { GEO_APIs } from "apihandlers/geography";
import { LABELS } from "common/lables";
import { COLORS } from "common/colors";
import { ListItemButton, ListItemIcon, Tooltip } from "@mui/material";

import "../../styles/index.css";

const MapTopFilters = (props: any) => {
  const {
    dealers,
    setCustomers,
    setPlottings,
    loading,
    getCustomers,
    getDealers,
    getFilteredDealers,
    filteredDealersList,
  } = props;

  const [stateArray, setStateArray] = useState<any>([]);
  const [checkedStates, setCheckedStates] = useState<any>([]); // States which are selected by the user
  const [districtArray, setDistrictArray] = useState<any>([]);
  const [checkedDistrict, setCheckedDistrict] = useState<any>([]);
  const [talukArray, setTalukArray] = useState<any>([]);
  const [checkedTaluk, setCheckedTaluk] = useState<any>([]);
  const [cityArray, setCityArray] = useState<any>([]);
  const [checkedCity, setCheckedCity] = useState<any>([]);
  const [routeArray, setRouteArray] = useState<any>([]);
  const [checkedRoute, setCheckedRoute] = useState<any>([]);
  const [filter, setFilter] = useState("");
  const [filterStates, setFilterStates] = useState<any>(null);
  const [filterDistrict, setFilterDistrict] = useState<any>(null);
  const [filterTaluks, setFilterTaluks] = useState<any>(null);
  const [filterCities, setFilterCities] = useState<any>(null);
  const [filterAreas, setFilterAreas] = useState<any>(null);
  const [filterDealers, setFilterDealers] = useState<any>(null);
  const [checkedDealer, setCheckedDealer] = useState<any>([]);

  const [selectedStates, setSelectedStates] = useState<any>(null);
  const [selectedDistrict, setSelectedDistrict] = useState<any>(null);
  const [selectedTaluk, setSelectedTaluk] = useState<any>(null);
  const [selectedCity, setSelectedCity] = useState<any>(null);
  const [selectedRoute, setSelectedRoute] = useState<any>(null);
  const [selectedDealers, setSelectedDealers] = useState<any>(null);

  useEffect(() => {
    if (loading) {
      getStates();
    }
  }, [loading]);

  const getStates = async () => {
    try {
      const args = {
        activeStatus: "true",
      };
      const res: any = await GEO_APIs.getStates(args);
      if (res.status === 200) {
        const states = res.response.records;
        let list = states.map((state, i) => {
          return { id: state.id, label: state.stateName };
        });
        setStateArray(list);
      }
    } catch (error) {
      console.log("getStates: ", error);
    }
  };

  const getDistrict = async (stateIds) => {
    try {
      const args = {
        stateIds,
        activeStatus: "true",
      };
      const res: any = await GEO_APIs.getDistricts(args);
      if (res.status === 200) {
        const districts = res.response.records;
        let list = districts.map((district, i) => {
          return {
            id: district.id,
            label: district.districtName,
            stateId: district.stateId,
          };
        });
        console.log("getDistricts ", list);
        setDistrictArray(list);
      }
    } catch (error) {
      console.log("getDistricts: ", error);
    }
  };

  // taluk data
  const talukData = [];
  const getRegions = async (districtIds) => {
    try {
      const args = {
        districtIds,
        activeStatus: "true",
      };
      const res: any = await GEO_APIs.getRegions(args);
      if (res.status === 200) {
        const taluk = res.response.records;
        let list = taluk.map((taluk, i) => {
          return {
            id: taluk.id,
            label: taluk.regionName,
          };
        });
        setTalukArray(list);
      }
    } catch (error) {
      console.log("getRegion: ", error);
    }
  };

  // city data
  const getCity = async (districtIds, regionIds) => {
    try {
      const args = {
        minResponseMap: "true",
        districtIds,
        regionIds,
        activeStatus: "true",
      };
      const res: any = await GEO_APIs.getCities(args);
      if (res.status === 200) {
        let cityList = res.response.records.map((r) => {
          return {
            id: r.id,
            label: r.cityName,
          };
        });

        setCityArray(cityList);
      }
    } catch (error) {}
  };

  // Area data
  const getArea = async (districtIds, regionIds, cityIds) => {
    try {
      const args = {
        minResponseMap: "true",
        cityIds,
        regionIds,
        districtIds,
        activeStatus: "true",
      };
      const res: any = await GEO_APIs.getAreas(args);
      let routeList = res.response.records.map((r) => {
        return {
          id: r.id,
          label: r.areaName,
          cityId: r.cityId,
        };
      });
      setRouteArray(routeList);
    } catch (error) {}
  };

  // onSelect State
  const onSelectState = (checked: boolean, stateId = "") => {
    let stateList = checkedStates;
    if (checkedStates.indexOf(stateId) === -1) {
      stateList.push(stateId);
    } else {
      stateList = checkedStates.filter((s) => s !== stateId);
    }
    console.log("stateList", stateList);

    setCheckedStates(stateList);

    const statesDataPassing = stateList.toString();
    setSelectedStates(statesDataPassing);
    console.log("checked", statesDataPassing);
  };

  /*
   * On district selected
   */
  const onSelectDistrict = (checked: boolean, districtId = "") => {
    let districtList = checkedDistrict;
    if (checkedDistrict.indexOf(districtId) === -1) {
      districtList.push(districtId);
    } else {
      districtList = checkedDistrict.filter((d) => d !== districtId);
    }
    setCheckedDistrict(districtList);
    console.log("onSelectDistrict", districtList);

    const districtsDataPassing = districtList.toString();
    setSelectedDistrict(districtsDataPassing);
  };

  //selecting taluk

  const onSelectTaluk = (checked: boolean, regionId = "") => {
    let regionList = checkedTaluk;
    if (checkedTaluk.indexOf(regionId) === -1) {
      regionList.push(regionId);
    } else {
      regionList = checkedTaluk.filter((s) => s !== regionId);
    }
    setCheckedTaluk(regionList);
    const talukDataPassing = regionList.toString();
    setSelectedTaluk(talukDataPassing);
  };

  //selected City
  const onSelectCity = (checked: boolean, cityId = "") => {
    let cityList = checkedCity;
    if (checkedCity.indexOf(cityId) === -1) {
      cityList.push(cityId);
    } else {
      cityList = checkedCity.filter((c) => c !== cityId);
    }
    setCheckedCity(cityList);
    const cityDataPassing = cityList.toString();
    setSelectedCity(cityDataPassing);
  };

  //selected Areas
  const onSelectRoute = (checked: boolean, route = "") => {
    let routeList = checkedRoute.slice();
    if (checked) {
      if (!routeList.includes(route)) {
        routeList.push(route);
      }
    } else {
      routeList = routeList.filter((d) => d !== route);
    }
    setCheckedRoute(routeList);
    const routeDataPassing = routeList.toString();
    setSelectedRoute(routeDataPassing);
  };

  // selected Dealers
  const onDealerSelection = (checked: boolean, dealer = "") => {
    let dealerList = checkedDealer.slice();
    if (checked) {
      if (!dealerList.includes(dealer)) {
        dealerList.push(dealer);
      }
    } else {
      dealerList = dealerList.filter((d) => d !== dealer);
    }
    setCheckedDealer(dealerList);

    const dealersDataPassing = dealerList.toString();
    setSelectedDealers(dealersDataPassing);
  };

  const getCustomersDetails = () => {
    getCustomers(selectedDealers);
  };

  //Search Filter for States,districts,taluk
  const getSearchFilter = (e, t) => {
    if (filter.length != 0) {
      if (t === "state") {
        setFilterStates(true);
      } else {
        setFilterStates(false);
      }
      if (t === "district") {
        setFilterDistrict(true);
      } else {
        setFilterDistrict(false);
      }
      if (t === "taluk") {
        setFilterTaluks(true);
      } else {
        setFilterTaluks(false);
      }
      if (t === "city") {
        setFilterCities(true);
      } else {
        setFilterCities(false);
      }
      if (t === "area") {
        setFilterAreas(true);
      } else {
        setFilterAreas(false);
      }
      if (t === "dealer") {
        setFilterDealers(true);
      } else {
        setFilterDealers(false);
      }
    }
    console.log(e.target.value);
    setFilter(e.target.value.toLowerCase());
  };
  const filteredStates = null;
  // stateArray.filter((item) =>
  //   item.toLowerCase().includes(filter.toLowerCase())
  // );
  const filteredDistricts = null;
  //  districtArray.filter((item) =>
  //   item.toLowerCase().includes(filter.toLowerCase())
  // );
  const filteredTaluk = null;
  // talukArray.filter((item) =>
  //   item.toLowerCase().includes(filter.toLowerCase())
  // );
  const filteredCity = null;
  // cityArray.filter((item) =>
  //   item.toLowerCase().includes(filter.toLowerCase())
  // );
  const filteredRoute = null;
  // routeArray.filter((item) =>
  //   item.toLowerCase().includes(filter.toLowerCase())
  // );
  const filteredDealer = null;
  // dealerArray.filter((item) =>
  //   item.toLowerCase().includes(filter.toLowerCase())
  // );
  const dealersDropDown = filteredDealersList || dealers;
  console.log("stateArray", checkedStates);
  console.log("filteredDealersList", filteredDealersList);

  //  On selection of state,district,etc and onclose the data is filtered

  const getStatesLists = () => {
    getFilteredDealers({ stateIds: selectedStates });
    console.log("selectedStates", selectedStates);
    if (selectedStates.length !== 0) {
      getDistrict(selectedStates);
    } else {
      setDistrictArray([]);
      setSelectedDistrict([]);
      setTalukArray([]);
      setCityArray([]);
      setRouteArray([]);
    }
  };

  const getDistrictLists = () => {
    getDealers({ stateIds: selectedStates, districtIds: selectedDistrict });
    if (selectedDistrict.length !== 0 && selectedStates.length !== 0) {
      getRegions(selectedDistrict);
      getCity(selectedDistrict, selectedTaluk);
      getArea(selectedDistrict, selectedTaluk, selectedCity);
    } else {
      setTalukArray([]);
      setCityArray([]);
      setRouteArray([]);
    }
  };

  const getTalukLists = () => {
    getFilteredDealers({
      stateIds: selectedStates,
      districtIds: selectedDistrict,
      regionIds: selectedTaluk,
    });
    if (selectedTaluk.length !== 0) {
      getCity(selectedDistrict, selectedTaluk);
      getArea(selectedDistrict, selectedTaluk, selectedCity);
    } else {
      setCityArray([]);
      setRouteArray([]);
    }
  };

  const getCityLists = () => {
    getFilteredDealers({
      stateIds: selectedStates,
      districtIds: selectedDistrict,
      regionIds: selectedTaluk,
      cityIds: selectedCity,
    });
    console.log("selectedCity", selectedCity);
    if (selectedCity.length !== 0) {
      getArea(selectedDistrict, selectedTaluk, selectedCity);
    } else {
      setRouteArray([]);
    }
  };

  const getRouteLists = () => {
    getFilteredDealers({
      stateIds: selectedStates,
      districtIds: selectedDistrict,
      regionIds: selectedTaluk,
      cityIds: selectedCity,
      areaIds: selectedRoute,
    });
  };

  const manageAllFilter = () => {
    setDistrictArray([]);
    setSelectedStates(null);
    setSelectedDistrict(null);
    setSelectedTaluk(null);
    setSelectedCity(null);
    setSelectedRoute(null);
    setSelectedDealers(null);
    setCheckedDistrict([]);
    setCheckedStates([]);
    setTalukArray([]);
    setCheckedTaluk([]);
    setCityArray([]);
    setCheckedCity([]);
    setRouteArray([]);
    setCheckedRoute([]);
    setCheckedDealer([]);
    getFilteredDealers();
    setCustomers(null);
    setPlottings(false);
  };

  return (
    <>
      <div
        className="leftSideFilterOptions"
        onClick={manageAllFilter}
        style={{ top: "1rem" }}
      >
        <Tooltip title={LABELS.RESET} placement="right" arrow={true}>
          <ListItemButton>
            <ListItemIcon>
              <ReplayIcon />
            </ListItemIcon>
          </ListItemButton>
        </Tooltip>
      </div>
      <div className="mapTopFilters">
        <PopoverBtn
          text={
            LABELS.STATE +
            " (" +
            checkedStates.length +
            "/" +
            stateArray.length +
            ")"
          }
          type="contained"
          color="secondary"
          border="0.6rem"
          onClose={getStatesLists}
          className="topFilterButtons"
        >
          <div style={{ height: "20rem", width: "13rem", marginTop: "0.5rem" }}>
            <TxtRow
              placeholder={LABELS.SEARCH}
              onChange={(e) => {
                getSearchFilter(e, "state");
              }}
              value={filterStates ? filter : ""}
            />
            {filterStates ? (
              <>
                {filteredStates &&
                  filteredStates.map((filter, i) => {
                    return (
                      <div className="flexRow">
                        <ChkBox
                          id={filter}
                          text={filter}
                          controlled={true}
                          checked={checkedStates.indexOf(filter) > -1}
                          onChange={(e, f) => {
                            onSelectState(e, f);
                          }}
                        />
                      </div>
                    );
                  })}
              </>
            ) : (
              <>
                {stateArray &&
                  stateArray.map((state, i) => {
                    return (
                      <div className="flexRow" key={"state-" + state.id}>
                        <ChkBox
                          id={state.id}
                          text={state.label}
                          controlled={true}
                          checked={checkedStates.indexOf(state.id) > -1}
                          onChange={(e, val) => {
                            onSelectState(e, val);
                          }}
                        />
                      </div>
                    );
                  })}
              </>
            )}
          </div>
        </PopoverBtn>
        {/* distrit selection dropdown */}
        <PopoverBtn
          text={
            LABELS.DISTRICT +
            " (" +
            checkedDistrict.length +
            "/" +
            districtArray.length +
            ")"
          }
          type="contained"
          color="secondary"
          border="0.6rem"
          onClose={getDistrictLists}
          className="topFilterButtons"
        >
          <div className={"popoverFilter"}>
            <TxtRow
              placeholder={LABELS.SEARCH}
              onChange={(e) => {
                getSearchFilter(e, "district");
              }}
              value={filterDistrict ? filter : ""}
            ></TxtRow>
            {filterDistrict ? (
              <>
                {filteredDistricts &&
                  filteredDistricts.map((filter, i) => {
                    return (
                      <div className="flexRow">
                        <ChkBox
                          id={filter}
                          text={filter}
                          controlled={true}
                          checked={checkedDistrict.indexOf(filter) > -1}
                          onChange={(e, f) => {
                            onSelectDistrict(e, f);
                          }}
                        />
                      </div>
                    );
                  })}
              </>
            ) : (
              <>
                {districtArray &&
                  districtArray.map((district, i) => {
                    return (
                      <>
                        <div className="flexRow" key={"state-" + district.id}>
                          <ChkBox
                            id={district.id}
                            text={district.label}
                            controlled={true}
                            checked={checkedDistrict.indexOf(district.id) > -1}
                            onChange={(e, val) => {
                              onSelectDistrict(e, val);
                            }}
                          />
                        </div>
                      </>
                    );
                  })}
              </>
            )}
          </div>
        </PopoverBtn>
        <PopoverBtn
          text={
            LABELS.TALUK +
            " (" +
            checkedTaluk.length +
            "/" +
            talukArray.length +
            ")"
          }
          type="contained"
          border="0.6rem"
          color="secondary"
          onClose={getTalukLists}
          className="topFilterButtons"
        >
          <div className={"popoverFilter"}>
            <TxtRow
              placeholder={LABELS.SEARCH}
              onChange={(e) => {
                getSearchFilter(e, "taluk");
              }}
              value={filterTaluks ? filter : ""}
            ></TxtRow>

            {filterTaluks ? (
              <>
                {filteredTaluk &&
                  filteredTaluk.map((taluk, i) => {
                    return (
                      <div className="flexRow">
                        <ChkBox
                          id={taluk}
                          text={taluk}
                          controlled={true}
                          checked={checkedTaluk.indexOf(taluk) > -1}
                          onChange={(e, f) => {
                            onSelectTaluk(e, f);
                          }}
                        />
                      </div>
                    );
                  })}
              </>
            ) : (
              <>
                {talukArray &&
                  talukArray.map((taluk, i) => {
                    return (
                      <div className="flexRow" key={"taluk-" + taluk.id}>
                        <ChkBox
                          id={taluk.id}
                          text={taluk.label}
                          controlled={true}
                          checked={checkedTaluk.indexOf(taluk.id) > -1}
                          onChange={(e, f) => {
                            onSelectTaluk(e, f);
                          }}
                        />
                      </div>
                    );
                  })}
              </>
            )}
          </div>
        </PopoverBtn>
        {/* city selection */}
        <PopoverBtn
          text={
            LABELS.CITY +
            " (" +
            checkedCity.length +
            "/" +
            cityArray.length +
            ")"
          }
          border="0.6rem"
          type="contained"
          color="secondary"
          onClose={getCityLists}
          className="topFilterButtons"
        >
          <div className={"popoverFilter"}>
            <TxtRow
              placeholder={LABELS.SEARCH}
              onChange={(e) => {
                getSearchFilter(e, "city");
              }}
              value={filterCities ? filter : ""}
            ></TxtRow>
            {filterCities ? (
              <>
                {filteredCity &&
                  filteredCity.map((city, i) => {
                    return (
                      <div className="flexRow">
                        <ChkBox
                          id={city}
                          text={city}
                          controlled={true}
                          checked={checkedCity.indexOf(city) > -1}
                          onChange={(e, f) => {
                            onSelectCity(e, f);
                          }}
                        />
                      </div>
                    );
                  })}
              </>
            ) : (
              <>
                {cityArray &&
                  cityArray.map((city, i) => {
                    return (
                      <div className="flexRow" key={"city-" + city.id}>
                        <ChkBox
                          id={city.id}
                          text={city.label}
                          controlled={true}
                          checked={checkedCity.indexOf(city.id) > -1}
                          onChange={(e, f) => {
                            onSelectCity(e, f);
                          }}
                        />
                      </div>
                    );
                  })}
              </>
            )}
          </div>
        </PopoverBtn>
        {/* Route selection */}
        <PopoverBtn
          text={
            LABELS.ROUTES +
            " (" +
            checkedRoute.length +
            "/" +
            routeArray.length +
            ")"
          }
          border="0.6rem"
          type="contained"
          color="secondary"
          onClose={getRouteLists}
          className="topFilterButtons"
        >
          <div className={"popoverFilter"}>
            <TxtRow
              placeholder={LABELS.SEARCH}
              onChange={(e) => {
                getSearchFilter(e, "area");
              }}
              value={filterAreas ? filter : ""}
            ></TxtRow>
            {filterAreas
              ? filteredRoute &&
                filteredRoute.map((route, i) => {
                  return (
                    <div className="flexRow">
                      <ChkBox
                        id={route}
                        text={route}
                        controlled={true}
                        checked={checkedRoute.indexOf(route) > -1}
                        onChange={(e, f) => {
                          onSelectRoute(e, f);
                        }}
                      />
                    </div>
                  );
                })
              : routeArray &&
                routeArray.map((route, i) => {
                  return (
                    <div className="flexRow" key={"route-" + route.id}>
                      <ChkBox
                        id={route.id}
                        text={route.label}
                        controlled={true}
                        checked={checkedRoute.indexOf(route.id) > -1}
                        onChange={(e, f) => {
                          onSelectRoute(e, f);
                        }}
                      />
                    </div>
                  );
                })}
          </div>
        </PopoverBtn>
        <PopoverBtn
          text={
            LABELS.DEALERS +
            " (" +
            checkedDealer.length +
            "/" +
            dealersDropDown.length +
            ")"
          }
          type="contained"
          className="topFilterButtons"
          color="secondary"
          border="0.6rem"
          // onClose={getCustomerLists}
        >
          <div className="popoverFilter" style={{ width: "15rem" }}>
            <TxtRow
              placeholder={LABELS.SEARCH}
              onChange={(e) => {
                getSearchFilter(e, "dealer");
              }}
              value={filterDealers ? filter : ""}
            ></TxtRow>
            {filterDealers
              ? filteredDealer &&
                filteredDealer.map((dealer, i) => {
                  return (
                    <div className="flexRow">
                      <ChkBox
                        id={dealer}
                        text={dealer}
                        controlled={true}
                        checked={checkedDealer.indexOf(dealer) > -1}
                        onChange={(e, f) => {
                          onDealerSelection(e, f);
                        }}
                      />
                    </div>
                  );
                })
              : dealersDropDown &&
                dealersDropDown.map((dealer, i) => {
                  return (
                    <div
                      className="flexRow"
                      style={{ marginBottom: "8px" }}
                      key={"dealer-" + dealer.id}
                    >
                      <ChkBox
                        id={dealer.id}
                        text={dealer.label}
                        controlled={true}
                        checked={checkedDealer.indexOf(dealer.id) > -1}
                        onChange={(e, val) => {
                          onDealerSelection(e, val);
                        }}
                      />
                    </div>
                  );
                })}
          </div>
        </PopoverBtn>
        <Btn
          text={LABELS.LOAD}
          bgColor={COLORS.SAVE_GREEN}
          onClick={getCustomersDetails}
          className="filterLoadBtn"
        />
      </div>
    </>
  );
};

export default MapTopFilters;
